import React from 'react';
export function Footer() {
  return <footer className="bg-wellness-dark text-white/70 py-12 px-4 text-center" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        <p className="mb-4 font-heading text-xl text-white" data-id="element-38">
          Programa Antiinflamatorio Natural
        </p>
        <p className="text-sm mb-6" data-id="element-39">
          Descargo de responsabilidad: Este producto no sustituye el consejo
          médico profesional. Consulte a su médico antes de comenzar cualquier
          dieta o programa de salud, especialmente si tiene condiciones médicas
          preexistentes.
        </p>
        <div className="flex justify-center space-x-6 text-sm mb-8" data-id="element-40">
          <a href="#" className="hover:text-white transition-colors" data-id="element-41">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-42">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-43">
            Contacto
          </a>
        </div>
        <p className="text-xs" data-id="element-44">
          &copy; {new Date().getFullYear()} Programa Antiinflamatorio Natural.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}